<template>
	<div class="header d-print-none">
		<div class="header-left">
			<div class="navigation-toggler">
				<a href="#" data-action="navigation-toggler">
					<icon data-feather="menu"></icon>
				</a>
			</div>
			<div class="header-logo">
				<a href="" style="font-weight: bold;font-size: 25px;">
					<!-- <img class="logo" src="../../../assets/media/image/logo.png" alt="logo">
					<img class="logo-light" src="../../../assets/media/image/logo-light.png" alt="light logo"> -->
					<img class="logo" src="../../../assets/image/logo/logo_2.png" alt="image">

				</a>
			</div>
		</div>
		<div class="header-body">
			<div class="header-body-left">
				<div class="page-title">
					<!-- <h4>{{routes.find(d=>d.path==$route.matched[0].path).name}}</h4> -->
					<el-menu style="height: 55px;" :default-active="activename" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
						<el-menu-item index="/home/index">
							<i class="el-icon-house"></i>主页
						</el-menu-item>
						<el-menu-item index="/procure/product">
							<i class="el-icon-goods"></i>商品
						</el-menu-item>
					<!-- 	<el-menu-item index="/order/promote22232">
							<i class="el-icon-tickets"></i>订单
						</el-menu-item>
					<el-menu-item index="/order/order2023">
						<i class="el-icon-tickets"></i>订单(2023)
					</el-menu-item> -->
					
						<el-submenu index="order">
							<template slot="title"><i class="el-icon-tickets"></i>订单</template>						
							<el-menu-item index="/order/promote22232">
								<i class="el-icon-tickets"></i>订单(2024)
							</el-menu-item>
							<el-menu-item index="/order/order2023">
								<i class="el-icon-tickets"></i>订单(2023)
							</el-menu-item>
							
						</el-submenu>
						<el-menu-item index="/order/receipt">
							<i class="el-icon-coin"></i>打款
						</el-menu-item>
						<!-- <el-submenu index="procure">
							<template slot="title"><i class="el-icon-sell"></i>下单</template>
							<el-menu-item index="/procure/product">
								<i class="el-icon-goods"></i>商品列表
							</el-menu-item>
							<el-menu-item index="/procure/cart">
								<i class="el-icon-shopping-cart-2"></i>购物车
							</el-menu-item>
						</el-submenu>
						<el-submenu index="order">
							<template slot="title"><i class="el-icon-document-copy"></i>订单</template>
							<el-menu-item index="/order/promote22232">
								<i class="el-icon-tickets"></i>订单管理
							</el-menu-item>
							
						</el-submenu> -->
						<el-submenu index="assets">
							<template slot="title"><i class="el-icon-user"></i>报表</template>						
							<el-menu-item index="/assets/index">
								<i class="el-icon-user"></i>账户余额(2024)
							</el-menu-item>
							<el-menu-item index="/assets/index2023">
								<i class="el-icon-user"></i>账户余额(2023)
							</el-menu-item>
							<el-menu-item index="/order/dataCenterpro">
								<i class="el-icon-reading"></i>销售报表(2024)
							</el-menu-item>
							<el-menu-item index="/order/dataCenterpro2023">
								<i class="el-icon-reading"></i>销售报表(2023)
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</div>
			</div>
			<div class="header-body-right">
				<ul class="navbar-nav">


					<!-- begin::header fullscreen -->
				<!-- 	<li class="nav-item dropdown">
						<a href="#" @click="handleFullscreen" class="nav-link" title="Fullscreen" data-toggle="fullscreen">
							<div v-show="!isFull">
								<icon data-feather="maximize"></icon>
							</div>
							<div v-show="isFull">
								<i data-feather="minimize"></i>
							</div>
						</a>
					</li> -->
					<!-- end::header fullscreen -->

					<!-- begin::header search -->
					<!-- 					<li class="nav-item">
						<a href="#" class="nav-link" title="Search" data-toggle="dropdown">
							<icon data-feather="search"></icon>
						</a>
						<div class="dropdown-menu p-2 dropdown-menu-right">
							<form>
								<div class="input-group">
									<input type="text" class="form-control" placeholder="Search">
									<div class="input-group-prepend">
										<button class="btn" type="button">
											<icon data-feather="search"></icon>
										</button>
									</div>
								</div>
							</form>
						</div>
					</li> -->
					<!-- end::header search -->

					<!-- begin::header notification dropdown -->
					<!-- <li class="nav-item">
						<el-dropdown trigger="click">
							<a href="#" @click="ii" class="nav-link" title="新消息" :class="messageList.length>0?'nav-link-notify':''">
								<icon data-feather="bell"></icon>
							</a>
							<el-dropdown-menu slot="dropdown" style="margin-top: 0px;">
								<div style="width: 270px;">
									<div class="bg-dark p-4 text-center d-flex justify-content-between align-items-center">
										<h5 class="mb-0">通知</h5>
										<small class="opacity-7" v-if="messageList.length>0">{{messageList.length}}份未读通知</small>
										<small class="opacity-7" v-else>无未读通知</small>
									</div>

									<div style="height: 279px;overflow: auto;">
										<a href="#" class="d-flex align-items-center" style="padding: 10px 0 10px 14px;border-bottom:1px solid beige ;"
										 v-for="(item,index) in messageList" @click="lookInfo(item.F_MessageId,item.F_keywordId,index)">
											<div>
												<figure class="avatar mr-2">
													<span class="avatar-title bg-success-bright text-success rounded-circle" v-if="item.F_Title=='订单已发货'">
														<i class="el-icon-s-order"></i>
													</span>
													<span class="avatar-title bg-warning-bright text-warning rounded-circle" v-else-if="item.F_Title=='订单支付超时'">
														<i class="el-icon-s-order"></i>
													</span>
													<span class="avatar-title bg-danger-bright text-danger rounded-circle" v-else-if="item.F_Title=='订单已驳回'">
														<i class="el-icon-s-order"></i>
													</span>
													<span class="avatar-title bg-info-bright text-info rounded-circle" v-else>
														<i class="el-icon-s-order"></i>
													</span>
												</figure>
											</div>
											<div class="flex-grow-1">
												<p class="mb-0 line-height-20 d-flex justify-content-between">
													<span style="font-size: 13px;">订单编号 :{{item.F_Code}}</span>
												</p>
												<div style="font-size: 12px;color: #bbbed1;">
													<span>{{item.F_Title}}</span>
													<span style="float: right;margin-right: 15px;">{{showtime(item.F_CreateDate)}}</span>
												</div>

											</div>
										</a>
									</div>
								</div>

							</el-dropdown-menu>
						</el-dropdown>
					</li> -->
					<!-- end::header notification dropdown -->
					<!-- BEGIN: Cart -->
					<li class="nav-item">
						<a href="#" title="购物车" class="nav-link" data-toggle="dropdown">
							
							<router-link to="/procure/cart">
								<!-- <icon data-feather="shopping-bag"></icon> -->
								<i class="el-icon-shopping-cart-2"></i>购物车(<i style="color: red;font-size: 16px;">{{cartCount}}</i>)
							</router-link>
						</a>
						<!-- <el-badge :value="cartCount==0?null:cartCount" :max="99" style="height: 35.43px;">
							
						</el-badge> -->

					</li>
					<!-- END: Cart -->

					<!-- begin::settings -->
					<!-- <li class="nav-item dropdown">
						<a href="#" class="nav-link" title="Settings" data-sidebar-target="#settings" @click="sidebarShow=true;sidebar2Show=true">
							<icon data-feather="link"></icon>
						</a>
					</li> -->
					<!-- end::settings -->
					<!-- begin::user menu -->
					<li class="nav-item " >
						<a href="#" class="nav-link" title="User menu" data-sidebar-target="#user-menu" @click="sidebarShow=true;sidebar1Show=true">
							<span class="mr-2 d-sm-inline d-none" ><i class="el-icon-user"></i>账户管理</span> 
							<!-- <figure  style="width: 90px;" class="avatar avatar-sm">
								<i class="el-icon-user"></i>账户管理
								<img src="../../../assets/media/image/user/women_avatar1.jpg" class="rounded-circle" alt="avatar">
							</figure> -->
						</a>
					</li>
					<!-- end::user menu -->

				</ul>

				<!-- begin::mobile header toggler -->
				<ul class="navbar-nav d-flex align-items-center">
					<li class="nav-item header-toggler">
						<a href="#" class="nav-link">
							<icon data-feather="arrow-down"></icon>
						</a>
					</li>
				</ul>
				<!-- end::mobile header toggler -->
			</div>
		</div>
		<!-- BEGIN: User Menu -->
		<div class="sidebar-group" :class="{'show':sidebarShow}" @click="sidebarShow=false;">
			<div class="sidebar" :class="{'show':sidebar1Show}" id="user-menu" @click.stop="">
				<div class="py-4 text-center " style="padding-top:0rem!important">
					<div class="py-4 text-center" :style="backgroundImg" style="margin-top: 0;opacity: 0.8;">
						<!-- <figure class="avatar avatar-lg mb-3 border-0">
							<img src="../../../assets/media/image/user/women_avatar1.jpg" class="rounded-circle" alt="image">
						</figure>
						<h5 class="d-flex align-items-center justify-content-center">超级管理员</h5> -->
					</div>
					<div class="spacing">
						账户名称: <strong>{{username.F_CustomerName}}</strong>
					</div>
					<hr width="90%" />
					<div class="spacing">
						联系人: <strong>{{username.F_Salesman}}</strong>
					</div>
					<hr width="90%" />
					<!-- <div class="spacing">
						地址: <strong>{{username.F_Address}}</strong>
					</div> -->
					<!--					<hr width="90%" />-->
					<div class="spacing">
						电话: <strong>{{username.F_Phone}}</strong>
					</div>
					<hr width="90%" />
				</div>
				<div class="card mb-0 card-body shadow-none">
					<div class="mb-4">
						<div class="list-group list-group-flush">
							<div class="click">
								<a href="javascript:;" class="list-group-item p-l-r-0" @click="sidebar1Show=false;sidebar2Show=true;">切换账户</a>
								<!-- <button @click="gotolink" class="btn btn-success">点击跳转页面</button> -->
								<!-- <el-button type="text" @click="open">修改密码</el-button> -->
								<el-button type="text" @click="dialogFormVisible = true">修改密码</el-button>

								<el-dialog append-to-body title="修改密码" :visible.sync="dialogFormVisible" width="600px">
									<el-form :model="form">
										<el-form-item label="原密码" :label-width="formLabelWidth">
											<el-input v-model="form.name" autocomplete="off" type="password"></el-input>
										</el-form-item>
										<el-form-item label="新密码" :label-width="formLabelWidth">
											<el-input v-model="form.newname" autocomplete="off" type="password"></el-input>
										</el-form-item>
										<el-form-item label="确认密码" :label-width="formLabelWidth">
											<el-input v-model="form.newsname" autocomplete="off" type="password"></el-input>
										</el-form-item>
									</el-form>
									<div slot="footer" class="dialog-footer">
										<el-button @click="dialogFormVisible = false;cancel()">取 消</el-button>
										<el-button type="primary" @click="changePassword">确 定</el-button>
									</div>
								</el-dialog>

								<a href="javascripts:;" class="list-group-item p-l-r-0 text-danger" data-sidebar-target="#settings" @click="loginout">退出登录</a>
							</div>
						</div>
					</div>

				</div>
			</div>
			<div class="sidebar" :class="{'show':sidebar2Show}" id="settings" @click.stop="">
				<div class="card">
					<div class="card-body">
						<h6 class="card-title">切换账号</h6>
						<ul class="list-group list-group-flush">
							<li class="list-group-item pl-0 pr-0" v-for="(item,index) in relations">
								<div class="custom-control">
									<a href="javascript:;" @click="handleChangeAccount(item['F_CustomerId'])">{{item["F_CustomerName"]}}</a>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

		<!-- END: User Menu -->
	</div>
</template>

<script>
	import Icon from '@/components/Icon.vue'
	import request from '@/utils/request'
	export default {
		components: {
			Icon
		},
		data() {
			return {
				backgroundImg: {
					backgroundImage: "url(" + require("@/assets/media/image/image1.jpg") + ")",
					backgroundRepeat: "no-repeat",
					backgroundSize: "100% 100%",
					marginTop: "5px",
				},
				activename: '/home/index',
				isFull: false,
				sidebarShow: false,
				sidebar1Show: false,
				sidebar2Show: false,
				relations: [],
				username: [],
				F_CustomerId: '',
				dialogTableVisible: false,
				dialogFormVisible: false,
				form: {
					name: '',
					newname: '',
					newsname: '',
				},
				formLabelWidth: '120px',
				dataForm: [],
				messageList: [],
				timer: null
			}
		},
		computed: {
			'routes': vm => vm.$router.options.routes,
			user: function() {
				return this.$store.state.user
			},
			cartCount() {
				return this.$store.state.count;
			}
		},
		created() {

			this.activename = this.$route.fullPath
			request({
					url: 'DRPAPI.ashx?a=getRelationCustomer',
					method: 'get',
					data: {}
				}).then(res => {
					
					if (res.code == 200) {
						
						this.relations = res.data
					}
				}),
			//获取用户信息
			request({
					url: 'DRPAPI.ashx?a=getuserinfo',
					//url: '/shop/user/getinfo',
					method: 'get',
					data: {
						// APPKEY:this.data.F_CustomerIds
						// keyValue:F_CustomerId	
					},
				}).then(res => {
					if(res.code==200){
						this.username = res.data
					}else{
						this.$router.push("/login");
					}
					
				})

				request({
					url: 'DRPAPI.ashx?a=getcartlist',
					// url: '/shop/cart/GetList',
					method: 'get',
					data: {
						queryJson: JSON.stringify({
							keyword: '',
							F_Viewer: 'Customer'
						})
					}
				}).then(res => {
					this.cartNum = res.data.length
					this.$store.commit('getcount', this.cartNum)
				}),
				this.getInfo(),
				this.timer = window.setInterval(() => {
					setTimeout(this.getInfo(), 0)
				}, 30000)

		},
		watch: {

			sidebarShow: function(v) {
				if (v) {
					//禁止滚动
					var mo = function(e) {
						e.preventDefault();
					};
					document.body.style.overflow = 'hidden';
					document.addEventListener("touchmove", mo, false); //禁止页面滑动
				} else {
					var mo = function(e) {
						e.preventDefault();
					};
					document.body.style.overflow = ''; //出现滚动条
					document.removeEventListener("touchmove", mo, false);
					this.sidebar1Show = false;
					this.sidebar2Show = false;
				}
			},
			'messageList.length': function(v) {
				if (v <= 0) {
					this.timer = window.setInterval(() => {
						setTimeout(this.getInfo(), 0)
					}, 30000)
				} else {
					clearInterval(this.timer);
					this.timer = null
				}
			}
		},
		methods: {
			handleSelect() {

			},
			open() {
				this.$prompt('请输入密码',
					'提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',

					},
				)

				this.$msgbox({
						title: '消息', // message: message,
						message: h('div', null, [
							h('el-input', {
								props: {
									value: this.value1,
								},
								on: {
									change: this.handleChange
								}
							})
						]),
						showCancelButton: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消'
					})

					.then(({
						value
					}) => {
						this.$message({
							type: 'success',
							message: '你的密码是: ' + value
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '取消输入'
						});
					});

			},
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			loginout() {
				this.$store.state.token = null
				this.$cookies.set("user_token", null)
				this.$router.push("/login")
			},
			//修改密码
			//取消按钮
			cancel() {
				this.form.name = ''
				this.form.newname = ''
				this.form.newsname = ''
			},
			//确定按钮
			changePassword() {
				if(this.form.name==""){
					this.$message({
						message: '请输入原密码',
						type: 'error'
					});
					return
				}
				if(this.form.newname==""){
					this.$message({
						message: '请输入密码',
						type: 'error'
					});
					return
				}
				if(this.form.newsname==""){
					this.$message({
						message: '请输入确认密码',
						type: 'error'
					});
					return
				}
				if(this.form.newname!=this.form.newsname){
					this.$message({
						message: '两次输入密码不一致',
						type: 'error'
					});
					return
				}
				
				
				request({
					//url: 'shop/user/ChangePassword',
					url: 'DRPAPI.ashx?a=ChangePassword',
					method: 'post',
					data: {
						opass: this.form.name,
						pass: this.form.newname
					}
				}).then(res => {
					if (res.code == 200) {
						this.form.name = ''
						this.form.newname = ''
						this.form.newsname = ''
						this.dialogFormVisible = false
						this.$message({
							message: res.data,
							type: 'success'
						});
						// this.$router.push("/login")
					} else {
						this.$message({
							message: res.info,
							type: 'error'
						});
					}
				})
			},
			handleChangeAccount(id) {
				request({
					url: '/shop/user/ChangeAccount',
					method: 'post',
					data: {
						keyValue: id
					}
				}).then(res => {
					//console.log(res)
					if (res.code == 200) {
						let token = res["data"]["Token"]
						this.$store.state.token = token
						this.$cookies.set("user_token", token)
						location.reload()
					}
				})
			},
			handleFullscreen() {
				if (!this.isFull) {
					var element = document.documentElement;
					if (element.requestFullscreen) {
						element.requestFullscreen();
					} else if (element.msRequestFullscreen) {
						element.msRequestFullscreen();
					} else if (element.mozRequestFullScreen) {
						element.mozRequestFullScreen();
					} else if (element.webkitRequestFullscreen) {
						element.webkitRequestFullscreen();
					}
					this.isFull = true
				} else {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					} else if (document.mozCancelFullScreen) {
						document.mozCancelFullScreen();
					} else if (document.webkitExitFullscreen) {
						document.webkitExitFullscreen();
					}
					this.isFull = false
				}

			},
			//获取通知
			getInfo() {
				request({
					// url: '/Drp/Message/GetCustomerList',
					url: 'DRPAPI.ashx?a=getmessagelist',
					method: 'get',
					data: {
						pagination: JSON.stringify({
							rows: 999,
							page: 1,
							_sidx: "F_CreateDate"
						}),
						queryJson: JSON.stringify({
							keyword: '',
							F_Viewer: 'Customer'
						})
					}
				}).then(res => {
					this.messageList = res.data.rows
				})
			},
			ii() {
				this.getInfo()
			},
			//点击清除消息
			lookInfo(id, F_keywordId, index) {
				this.$router.push({
					path: '/order/order',
					query: {
						id: F_keywordId
					}
				})
				request({
					url: '/Drp/Message/IsViewed',
					method: 'POST',
					data: {
						keyValue: id
					}
				}).then(res => {
					this.messageList.splice(index, 1)
				})

			},
			showtime(time) {
				let date =
					typeof time === "number" ?
					new Date(time) :
					new Date((time || "").replace(/-/g, "/"));
				let diff = (new Date().getTime() - date.getTime()) / 1000;
				let dayDiff = Math.floor(diff / 86400);

				let isValidDate =
					Object.prototype.toString.call(date) === "[object Date]" &&
					!isNaN(date.getTime());

				if (!isValidDate) {
					window.console.error("不是有效日期格式");
				}
				const formatDate = function(date) {
					let today = new Date(date);
					let year = today.getFullYear();
					let month = ("0" + (today.getMonth() + 1)).slice(-2);
					let day = ("0" + today.getDate()).slice(-2);
					let hour = today.getHours();
					let minute = today.getMinutes();
					let second = today.getSeconds();
					// return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
					return `${year}-${month}-${day}`;
				};

				if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {
					return formatDate(date);
				}
				return (
					(dayDiff === 0 &&
						((diff < 60 && "刚刚") ||
							(diff < 120 && "1分钟前") ||
							(diff < 3600 && Math.floor(diff / 60) + "分钟前") ||
							(diff < 7200 && "1小时前") ||
							(diff < 86400 && Math.floor(diff / 3600) + "小时前"))) ||
					(dayDiff === 1 && "昨天") ||
					(dayDiff < 7 && dayDiff + "天前") ||
					(dayDiff < 31 && Math.floor(dayDiff / 7) + "周前")
				);
			}
		}
	}
</script>

<style>
	.click {
		margin-top: 50px;
		text-align: center;
	}

	.spacing {
		margin-top: 10px;
		font-weight: bolder;
	}

	.el-menu.el-menu--horizontal {
		border-bottom: solid 0px !important;
	}
	.header {
		height: 60px !important;
		
	}
	.el-menu-item .is-active{
		height: 43px !important;
		
	}
	.content {
	    padding-left: 8px !important;
	    padding-top: 86px !important;
		padding-right: 8px !important;
	}
	
</style>
